import { EdaDialogCloseEvent, EdaDialog } from '@eda/shared/components/shared-components.index';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PanelChartComponent } from '../panel-charts/panel-chart.component';
import { PanelChart } from '../panel-charts/panel-chart';
import { UserService } from '@eda/services/service.index';
import { EdaChart } from '@eda/components/eda-chart/eda-chart';
import { StyleProviderService } from '@eda/services/service.index';
import { DynamicTextConfig } from '../panel-charts/chart-configuration-models/dynamicText-config';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EdaDialog2Component } from '@eda/shared/components/shared-components.index';
import { ColorPickerModule } from 'primeng/colorpicker';

@Component({
  standalone: true,
  selector: 'app-dynamicText-dialog',
  templateUrl: './dynamicText-dialog.component.html',
  styleUrls: ['./dynamicText-dialog.component.css'],
  imports: [FormsModule, CommonModule, EdaDialog2Component, PanelChartComponent, ColorPickerModule],
})

export class dynamicTextDialogComponent implements OnInit {
  @Input() controller: any;
  @ViewChild('PanelChartComponent', { static: false }) PanelChartComponent: PanelChartComponent;

  public dialog: EdaDialog;
  public panelChartConfig: PanelChart = new PanelChart();
  public chart: EdaChart;
  public value: number;
  public operand: string;
  @Output() color;
  public originalColors: string;
  public modifiedFontPoints: number = 0;
  @Output() messageEvent = new EventEmitter<any>();
  public disabled:boolean;
  public display:boolean=false;
  public title:string=$localize`:@@ChartProps:PROPIEDADES DEL GRAFICO`;

  constructor( private userService: UserService,private styleProviderService : StyleProviderService) {}
  
  saveChartConfig() {
    this.PanelChartComponent.fontColor=this.color;
    this.messageEvent.emit(this.color)
    this.PanelChartComponent.props.config.getConfig["color"]=this.color
    this.onClose(EdaDialogCloseEvent.UPDATE,
      {
        color: this.color,
        modifiedFontPoints: this.modifiedFontPoints,
      });
  }

  modifySize(newValue?: number) {
    const min = -90;
    const max = 300;
    if (newValue !== undefined) {
        this.modifiedFontPoints = Math.min(max, Math.max(min, newValue || 0));
    } else {
        this.modifiedFontPoints = Math.min(max, Math.max(min, this.modifiedFontPoints));
    }
    const instance = this.PanelChartComponent.componentRef.instance;
    instance.inject.modifiedFontPoints = this.modifiedFontPoints;
    this.PanelChartComponent.componentRef.changeDetectorRef.detectChanges();
  }
  
  ngOnInit(): void {
    const panelChart = this.controller.params.panelChart;
    this.panelChartConfig = panelChart;
    const colorConfig = panelChart?.config?.config;
    // Función para encontrar el color real sin importar la profundidad
    function getDeepColor(obj: any): string | null {
    while (obj && typeof obj === 'object' && 'color' in obj) {
      obj = obj.color;
    }
    return typeof obj === 'string' ? obj : null;
  }
  const extractedColor = getDeepColor(colorConfig);

  // extractedColor si acabamos de modificar el color del texto manualmente, sino el de estilos
  this.color = !this.styleProviderService.loadingFromPalette ? extractedColor : this.styleProviderService.panelFontColor.source['_value'];
  this.originalColors = this.color;
  this.modifiedFontPoints = panelChart?.config?.getConfig()?.modifiedFontPoints || 0;

  this.display = true;
}

closeChartConfig() {
  this.panelChartConfig.config.setConfig(new DynamicTextConfig(this.originalColors));
  this.onClose(EdaDialogCloseEvent.NONE);
}
onClose(event: EdaDialogCloseEvent, response?: any): void {
    return this.controller.close(event, response);
  }

  handleInputColor(){
    this.PanelChartComponent.props.config.setConfig( this.color )
    this.PanelChartComponent.changeChartType();
  }

  rgb2hex(rgb): string {
    rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
    return (rgb && rgb.length === 4) ? '#' +
      ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) +
      ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2) +
      ('0' + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
  }

  hex2rgb(hex, opacity = 100): string {
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
  }

  fillWithZeros(n: number) {
    if (n < 10) return `0${n}`
    else return `${n}`;
  }
}